module.exports = __webpack_public_path__ + "media/images/winner-fc53e766a290a330fe73c7eabefd972a.svg";